var stepperI18n = {
  currentStep: 'Step %{stepNumber} (Current Step)',
  goto: 'Go to step %{stepNumber}',
  stepLabel: 'Step %{stepNumber}'
};
export default stepperI18n;